import { Outlet } from "react-router"
import Default from "./assets/visual_signup.svg"
import extendLogo from "@/assets/logo_dark_extended.svg"
import { PostHogPageView } from "@/feature/posthog/page-view"

export const PublicLayout = () => (
  <>
    <div className="h-screen bg-[#F5F5F5] w-full flex items-center justify-center">
      <section className="max-h-[752px] max-w-[1200px] w-full flex gap-5 h-full justify-center">
        <div className="max-w-[748px] w-full h-full rounded-md overflow-y-scroll">
          <Outlet />
        </div>
        <div className="max-w-[452px] w-full h-full rounded-md relative overflow-hidden">
          <img
            src={Default}
            alt="Curves and lines"
            className="object-cover w-full h-full"
          />
        </div>
      </section>
    </div>
    <title>Valueize - Login</title>
    <meta name="description" content="Login to Valueize" />
    <PostHogPageView />
  </>
)

export const LogoExtended = () => (
  <div className="flex justify-start items-start w-full">
    <img src={extendLogo} width={61} height={16} alt="Logo" />
  </div>
)
